// ============================================================
//  Modulos opcionales de FacturaGS
//
//  No todos los negocios compran lo mismo: el modulo de reparaciones,
//  por ejemplo, es de MK Solutions. Que modulos lleva cada distribucion
//  se declara en su cliente.json y se hornea al armar el pack, en
//  REACT_APP_MODULOS dentro de client/.env.production.
//
//  El valor por defecto depende del entorno, y esto NO es un detalle:
//  este mismo codigo es el que se compila para el deploy publico de
//  FacturaGS, que no es una distribucion de nadie. Si ahi los modulos se
//  encendieran solos, la demo mostraria un modulo que solo compro un
//  cliente. Asi que:
//
//    desarrollo -> todos encendidos, para poder trabajarlos
//    produccion -> SOLO lo declarado. Sin declaracion, ninguno.
//
//  Encender uno en produccion es siempre una decision explicita.
// ============================================================

export const MODULOS_DISPONIBLES = ['reparaciones'];

const declarados = process.env.REACT_APP_MODULOS;
const enProduccion = process.env.NODE_ENV === 'production';

export const MODULOS =
  declarados !== undefined
    ? declarados.split(',').map((m) => m.trim()).filter(Boolean)
    : enProduccion
      ? []
      : MODULOS_DISPONIBLES;

export const tieneModulo = (nombre) => MODULOS.includes(nombre);
